declare global {
  interface Window {
    pushToDataLayer: any
    dataLayer: any
  }
}

export function PushToDataLayer(...e: any[]) {
  window.dataLayer = window.dataLayer || []
  window.dataLayer.push(e)
}

/**
 * gtag tracking event.
 * @param eventName event name.
 * @param params an object of the event parameters.
 */
export const TrackEvent = (eventName: string, params: object) => {
  if (window.pushToDataLayer) {
    window.pushToDataLayer('event', eventName, params)
  } else {
    PushToDataLayer('event', eventName, params)
  }
}
